import { createTheme } from "@material-ui/core/styles";

export const theme = createTheme({
  palette: {
    primary: {
      light: "#9b7acc",
      main: "#5B2D8E",
      dark: "#3e1d63",
      contrastText: "#fff",
    },
    secondary: {
      light: "#9b7acc",
      main: "#5B2D8E",
      dark: "#3e1d63",
      contrastText: "#fff",
    },
  },
  overrides: {
    MuiOutlinedInput: {
      root: {
        borderRadius: 10,
        backgroundColor: "#fff",
        "&:hover $notchedOutline": {
          borderColor: "#5B2D8E",
        },
        "&$focused $notchedOutline": {
          borderColor: "#5B2D8E",
          borderWidth: 1.5,
        },
      },
      notchedOutline: {
        borderColor: "#e0e0e5",
        borderWidth: 1.5,
      },
    },
    MuiCheckbox: {
      root: {
        color: "#c0c0cc",
        "&$checked": {
          color: "#5B2D8E",
        },
      },
    },
  },
});
